export default __webpack_public_path__ + "static/6-implant-e6eb841e831f57a72290af176a14926a.png";